import { render, staticRenderFns } from "./telegramNotice.vue?vue&type=template&id=be83a5c2&scoped=true&"
import script from "./telegramNotice.vue?vue&type=script&lang=js&"
export * from "./telegramNotice.vue?vue&type=script&lang=js&"
import style0 from "./telegramNotice.vue?vue&type=style&index=0&id=be83a5c2&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be83a5c2",
  null
  
)

export default component.exports